module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 296
 ** module chunks = 0
 **/